import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "@react-email/components";
export default function TokenImage({ token }) {
    if (token === 'USDC') {
        return (_jsx(Text, { style: {
                borderRadius: '50%',
                background: 'linear-gradient(180deg, #4D83EF 0%, #145CEB 100%)',
                width: '16px',
                height: '16px',
                color: '#fff',
                fontWeight: 500,
                margin: '0px',
                padding: '0px',
                textAlign: 'center',
                fontSize: '10px',
                lineHeight: '17px'
            }, children: "$" }));
    }
    else if (token === 'PYUSD') {
        return (_jsx(Text, { style: {
                borderRadius: '50%',
                backgroundColor: '#0071F3',
                width: '16px',
                height: '16px',
                color: '#fff',
                fontWeight: 500,
                margin: '0px',
                padding: '0px',
                textAlign: 'center',
                fontSize: '10px',
                lineHeight: '17px'
            }, children: "P" }));
    }
    else if (token === 'USDT') {
        return (_jsx(Text, { style: {
                borderRadius: '50%',
                background: 'linear-gradient(180deg, #3FA862 0%, #348D52 100%)',
                width: '16px',
                height: '16px',
                color: '#fff',
                fontWeight: 500,
                margin: '0px',
                padding: '0px',
                textAlign: 'center',
                fontSize: '10px',
                lineHeight: '17px'
            }, children: "T" }));
    }
}
